import MapRepository from "@domain/repositories/MapRepository";
import UseCase from "@domain/UseCase";
import { Map } from "@domain/models/Map";

type Input = Map["id"];

type Output = Promise<void>;

export class DeleteMapUseCase implements UseCase<Input, Output> {
  constructor(private readonly mapRepository: MapRepository) {}

  execute(mapId: Input) {
    return this.mapRepository.delete(mapId);
  }
}
